import { useAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { getCountries } from '../api/legacy';
import { countriesAtom } from '../contexts/countries';
import { Country } from '../types/common';
import useMessageHandler from './useMessageHandler';
import useRequest from './useRequest';

export const useCountries = (): {
  data: Country[];
  isLoading: boolean;
} => {
  const { setError } = useMessageHandler();
  const [countries, setCountries] = useAtom(countriesAtom);
  const request = useRequest(getCountries, { skip: countries.length > 0 });

  useEffect(() => {
    if (request.data) {
      setCountries(request.data);
    }
  }, [request.data]);

  useEffect(() => {
    setError(request.error);
  }, [request.error]);

  return useMemo(
    () => ({
      data: countries,
      isLoading: request.loading,
    }),
    [countries, request.loading],
  );
};
